import { Button, ProgressTabAdv } from "../../../../../../components";
import { useEffect } from "react";

const PaymentSuccess = ({ onBack,tabs }) => {
    

     useEffect(() => {
   
    const timer = setTimeout(() => {
      onBack(); 
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
   
  return (
    <>
      <div className="p-5 flex flex-col flex-1 overflow-hidden">
        <div className="my-2">
          {/* <Button
            title="Success"
            color="black"
            variant="text"
             size="lg"
            fromLeft
            icon="arrow_left_alt"
            className="self-start text-lg font-medium !px-2"
            onClick={onBack}
          /> */}
        </div>
        <div className="h-40">
          <ProgressTabAdv tabs={tabs} />
        </div>
        <div className="flex flex-col items-center justify-center text-center ">
          <span className="material-symbols-outlined !text-7xl  !text-success drop-shadow-green-lg mb-4 rounded-full p-2 drop-shadow-5xl animate-bounce">
            check_circle
          </span>
          <h2 className="text-2xl font-medium ">
            Payment Successful
          </h2>

          <p className="mt-2 text-gray-600 ">
            Your purchase has been completed successfully. Thank you for your
            payment!
          </p>
        </div>
      </div>
    </>
  );
};
export default PaymentSuccess